import React from "react";
import { Field, Form } from "react-final-form";
import { submit, validate } from "./EditServicePartFormSubmit";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import { Col, Row } from "react-bootstrap";
import { t } from "i18next";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";

const EditServicePartForm = (props) => {
  const { initialValues, handleHide } = props;

  return (
    <Form
      initialValues={{
        ...initialValues,
        used:{value:initialValues?.used}
      }}
      onSubmit={(val) => submit(val, props)}
      validate={validate}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="EditServicePartForm">
          <Row>
            <Col xs={4}>
              <Field
                type="money"
                name="price"
                component={BMXTextField}
                label={t("global:editservicepartform.price")}
              />
            </Col>
            <Col xs={4}>
              <Field
                type="number"
                name="quantity"
                component={BMXTextField}
                label={t("global:editservicepartform.quantity")}
              />
            </Col>
            <Col xs={4}>
              <Field
                name="used"
                MenuProps={{sx:{ zIndex: "9999"} }}
                component={BMXSelectField}
                values={[{ value: true, name: t("global:yes") }, { value: false, name: t("global:no") }]}
                label={t("global:editservicepartform.used")}
              />
            </Col>
          </Row>
          <Row className=" d-flex justify-content-end">
            <Col className="mt-3 d-flex gap-3 justify-content-end">
              <BMXButton
                data-cy="submit"
                type="button"
                onClick={handleHide}
              >
                {t("global:close")}
              </BMXButton>
              <BMXButton
                data-cy="submit"
                bmxclass="Success"
                type="Submit"
                onClick={handleSubmit}
              >
                {t("global:add")}
              </BMXButton>
            </Col>
          </Row>
        </form>
      )}
    </Form>
  );
};

export default EditServicePartForm;
